// extracted by mini-css-extract-plugin
export default {"scroll":"styles_scroll__qD9-b"};